import ResizableScene from "../core/ResizableScene";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";
import { GameObject } from "./GameObject";

export class PointsIndicator extends GameObject {
	emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];
	stars: Phaser.GameObjects.Container[] = [];

	constructor(scene: ResizableScene, x: number, y: number, points?: number, offRamp?: boolean) {
		super(scene);
		this.setPosition(x, y);

		const rays = scene.add.image(0, 0, "scoreRays");
		this.add(rays);

		const particleContainer = scene.add.container(0, 0);
		this.add(particleContainer);
		//emitter
		//const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

		for (let i = 0; i < 4; i++) {
			const particles = scene.add.particles("pointParticle" + Phaser.Math.RND.between(1, 2));
			particleContainer.add(particles);

			const emitter = particles.createEmitter({
				alpha: { start: 1, end: 0.0 },
				scale: { min: 0.7, max: 1.1 },
				frequency: 300,
				lifespan: 500,
				angle: Phaser.Math.RND.between(-360, 360),
				speedX: { min: -300, max: 300 },
				speedY: { min: -150, max: 150 },
			});
			this.emitters.push(emitter);
			emitter.start();
		}

		/* star emitter */
		if (offRamp) {
			this.createStars(points);
		}
		if (points) {
			this.scene.soundManager.play("flagCollectSFX");
			const text = scene.add.text(0, 0, "+" + points, {
				fontSize: "80px",
				color: GameColors.WHITE,
				fontFamily: Fonts.DisneyJrBold,
			});
			text.setOrigin(0.5, 0.5);
			this.add(text);
		}

		scene.tweens.add({
			targets: rays,
			angle: 180,
			ease: Phaser.Math.Easing.Linear,
			duration: 2000,
		});

		this.scale = 0;
		scene.tweens.add({
			targets: this,
			scale: 1,
			ease: Phaser.Math.Easing.Back.Out,
			duration: 500,
		});

		scene.tweens.add({
			targets: this,
			alpha: 0,
			ease: Phaser.Math.Easing.Linear,
			delay: 400,
			duration: 1000,
			onComplete: () => this.destroy(),
		});

		if (points) {
			scene.tweens.add({
				targets: this,
				y: this.y - 80,
				ease: Phaser.Math.Easing.Linear,
				duration: 1400,
			});
		}

		this.angle = 10;
	}

	createStars(points: number): void {
		const container = new GameObject(this.scene);
		container.setPosition(this.x, this.y);

		const offset = { x: 25, y: 20 };
		const startY = 0 - offset.y;
		const startX = -100 + offset.x;
		const starNum = points == 100 ? 5 : 2;
		for (let i = 0; i < starNum; i++) {
			const starGroup = this.scene.add.container(startX + i * offset.x, startY - i * offset.y);
			container.add(starGroup);

			const star = this.scene.add.image(0, 0, "pickupStar");
			starGroup.add(star);
			star.setOrigin(0.5);
			this.scene.add.tween({
				targets: star,
				y: { from: -10, to: 10 },
				ease: Phaser.Math.Easing.Quadratic.InOut,
				yoyo: true,
				repeat: -1,
			});

			const particles = [this.scene.add.particles("sparkle1"), this.scene.add.particles("sparkle2")];
			for (let i = 0; i < 2; i++) {
				const manager = particles[i];
				starGroup.add(manager);

				const emitter = manager.createEmitter({ frequency: 500, delay: Phaser.Math.RND.integerInRange(0, 100) });
				emitter.setLifespan(1000);
				emitter.setGravity(0, 0);
				emitter.setSpeedX({ min: -10, max: 10 });
				emitter.setSpeedY({ min: -10, max: 10 });
				emitter.setAngle({ min: 0, max: 359 });
				// emitter.onParticleEmit(this.onParticleEmit, this);
				// emitter.tint.onUpdate = this.onParticleUpdate;
				// this.flagEmitters.push(emitter);
			}

			this.stars.push(starGroup);
		}
		this.scene.addObject(container, "game");
		this.tweenStars();
	}
	tweenStars(): void {
		for (let i = 0; i < this.stars.length; i++) {
			const star = this.stars[i];

			this.scene.tweens.killTweensOf(star.getAt(0));
			star.parentContainer.remove(star);
			this.scene.hudContainer.add(star);

			let point = new Phaser.Math.Vector2();
			point = this.scene.hudContainer
				.getWorldTransformMatrix()
				.transformPoint(this.x + star.x, this.y + star.y, point) as Phaser.Math.Vector2;
			point.set(point.x - this.scene.cameras.main.scrollX, point.y);
			star.setPosition(point.x, point.y);

			this.scene.tweens.add({
				targets: star,
				x: this.scene.ui.scoreGroup.x - this.scene.ui.scoreGroup.width * 0.3,
				y: this.scene.ui.scoreGroup.y,
				duration: 800,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			this.scene.tweens.add({
				targets: star,
				scale: 0,
				duration: 300,
				delay: 500,
				ease: Phaser.Math.Easing.Quadratic.Out,
				onComplete: star.destroy,
				onCompleteScope: star,
			});
		}
		this.stars = [];
	}
	static pauseEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.pause();
		}
	}

	static resumeEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.resume();
		}
	}
}
